import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  toast: {
    '&.MuiSnackbar-root': {
      top: '10%',
    },
  },
}));
